import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Moon, Sun, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil", id: "accueil" },
  { to: "/a-propos", label: "À propos", id: "apropos" },
  { to: "/studio", label: "Studio", id: "studio" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export default function Header({ dark, toggleDark }) {
  const [open, setOpen] = useState(false);
  const cls = ({ isActive }) => `nav-link ${isActive ? "text-[var(--accent)]" : ""}`;
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[var(--bg)]/80 border-b border-[var(--border)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--accent)] opacity-60" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-[var(--accent)]" />
          </span>
          <span className="font-serif text-2xl">Sem.IA</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end data-testid={`nav-link-${l.id}`} className={cls}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="theme-toggle-button" onClick={toggleDark} className="icon-btn" aria-label="Thème">
            {dark ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <Link to="/studio" data-testid="nav-cta-chat" className="btn-primary hidden md:inline-flex">Discuter avec Sem.IA</Link>
          <button data-testid="mobile-menu-button" className="icon-btn md:hidden" onClick={() => setOpen(!open)}>
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden flex flex-col px-5 pb-4 gap-3">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${l.id}`} className={cls}>{l.label}</NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
